import { useEffect, useState } from "react";
import ColorSchema from "../../kits/Color";
import { CloseIcon } from "../../kits/Icons";
import MakeMathematicalString from "../MakeMathematicalString";
export default function FormulationListDefine({
  mathPreview,
  setMathPreview,
  enterFormul,
  setEnterFormul,
  formulationList,
  setFormulationList,
  title = "",
  hasLimit = false,
  limitCount,
  compareOperator,
  attributeProductList,
  chooseMainProperty,
  attributeBaseOnProduct,
}) {
  const [firstOperator, setFirstOperator] = useState(true);
  const addToPreview = (value, type) => {
    let tempEnterFormul = enterFormul;
    let lastIndex = enterFormul.length - 1;
    let lastItem = enterFormul[enterFormul.length - 1];
    if (enterFormul.length == 0) setFirstOperator(false);
    if (
      type == "adjective" &&
      lastItem?.type != type &&
      lastItem.type == "operator"
    ) {
      tempEnterFormul.push({
        name: value.label,
        value: `prpr_id_${value.value}`,
        type: type,
      });
    } else if (
      (type == "number" && lastItem.type != "adjective") ||
      type == "operator"
    ) {
      if (lastItem?.type == type && type == "number") {
        let newItem = {
          ...lastItem,
          name: `${lastItem.value}${value}`,
          value: `${lastItem.value}${value}`,
        };
        enterFormul[lastIndex] = newItem;
      } else if (lastItem?.type != type) {
        tempEnterFormul.push({
          name: value,
          value: value,
          type: type,
        });
      }
    }
    setEnterFormul(tempEnterFormul);
    let tempMathPreview = "";

    tempMathPreview = tempEnterFormul
      .map((v) => v.name)
      .toString()
      .replaceAll(",", " ");

    setMathPreview(tempMathPreview);
  };
  const deleteFormul = (value, index) => {
    let formulatioListTemp = formulationList;
    formulatioListTemp.splice(index, 1);
    setFormulationList([...formulatioListTemp]);
    setFirstOperator(true);
    if (compareOperator) addToPreview("=", "operator");
  };
  useEffect(() => {
    if (!hasLimit && formulationList.length == 0) setFirstOperator(true);
    else setFirstOperator(false);
  }, [formulationList]);

  return (
    <div className="my-1">
      <h5
        style={{
          fontSize: 15,
          fontWeight: "bold",

          display: "inline-block",
          padding: "5px",
          borderRadius: "4px",
          color: "white",
        }}
        className=" bg-warning ms-5"
      >
        {title}
      </h5>
      <div style={{ width: "95%" }} className="mx-auto">
        <MakeMathematicalString
          mathPreview={mathPreview}
          setMathPreview={setMathPreview}
          enterFormul={enterFormul}
          setEnterFormul={setEnterFormul}
          formulationList={formulationList}
          setFormulationList={setFormulationList}
          hasLimit={hasLimit}
          limitCount={limitCount}
          compareOperator={compareOperator}
          firstOperator={firstOperator}
          setFirstOperator={setFirstOperator}
          addToPreview={addToPreview}
          attributeProductList={attributeProductList}
          chooseMainProperty={chooseMainProperty}
          attributeBaseOnProduct={attributeBaseOnProduct}
        />
      </div>

      <div
        className=" mx-auto border border-top-0 p-3  math-container"
        style={{
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          width: "95%",
        }}
      >
        {formulationList.length > 0 && (
          <div className="mt-2 mb-4">
            <div className="">
              <h5 className="" style={{ fontSize: 14, fontWeight: "bold" }}>
                {hasLimit && limitCount > 1
                  ? "لیست فرمولهای موجود"
                  : "فرمول موجود"}
              </h5>

              <ul
                style={{ listStyleType: "disc", lineHeight: 1.5 }}
                className="p-2"
              >
                {formulationList.map((v, i) => {
                  return (
                    <li>
                      <div className="d-flex align-items-center">
                        {v?.made_product_property_title != "" &&
                          v?.made_product_property_title != undefined &&
                          v?.made_product_property_title != null && (
                            <span className="me-1">
                              {v?.made_product_property_title}
                            </span>
                          )}
                        {v?.mathPreview}
                        <span onClick={() => deleteFormul(v, i)}>
                          <CloseIcon
                            containerIconClassName="bg-danger rounded-pill ms-1"
                            color={ColorSchema.white_custom}
                            style={{ width: 17, height: 17, cursor: "pointer" }}
                          />
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
